// extracted by mini-css-extract-plugin
module.exports = {"primary-color":"#1890ff","secondary-color":"#fff","white":"#fff","grey":"#d1d1fb","light-grey":"#e6ebf1","buttonContainer":"AnnouncementConfig_buttonContainer__2lfyX"};